import React from "react";

import { Trans } from "app/utils";

import facebook from "images/social/facebook.png";
import linkedin from "images/social/linkedin.png";
import twitter from "images/social/twitter.png";

const Status = () => (
  <div className="ProfileStatus clearfix">
    <div className="col-sm-12">
      <h3>
        <Trans>CultureHQ beta</Trans>
      </h3>
      <p>
        <Trans>
          CultureHQ is currently in beta. You can enjoy our core features at no
          cost (I know pretty awesome). We will be adding and removing features
          throughout this period. Our goal is to create the best possible
          experience for you and your organization.
        </Trans>
      </p>

      <h3>
        <Trans>Earn swag and rewards?</Trans>
      </h3>
      <p>
        <Trans>
          Introduce us to your HR leader or an appropriate contact at your
          organization. Send the introductory note to brian@culturehq.com and
          you win.
        </Trans>
      </p>

      <h3>
        <Trans>
          Lastly, we would love to hear what you think of our new platform
        </Trans>
      </h3>
      <p>
        <Trans>
          For questions and feedback -- please chat with us through the icon on the bottom right
        </Trans>
      </p>
      <p>
        <Trans>
          To spread the love about CultureHQ -- tag us on our social channels and use #CHQcommunity
        </Trans>
      </p>

      <div className="ProfileStatus__social-links">
        <a
          href="https://www.facebook.com/cultureHQ"
          target="_blank"
          rel="noopener noreferrer"
          className="ProfileStatus__social-link"
        >
          <img src={facebook} alt="facebook" />
        </a>
        <a
          href="https://twitter.com/culture_hq"
          target="_blank"
          rel="noopener noreferrer"
          className="ProfileStatus__social-link"
        >
          <img src={twitter} alt="twitter" />
        </a>
        <a
          href="https://www.linkedin.com/company/culturehq/"
          target="_blank"
          rel="noopener noreferrer"
          className="ProfileStatus__social-link"
        >
          <img src={linkedin} alt="linkedin" />
        </a>
      </div>

      <p>
        <Trans>Want to learn more about us? Visit us at our website: </Trans>{" "}
        <a href="https://www.culturehq.com/" target="_blank" rel="noopener noreferrer">CultureHQ.com</a>
      </p>
    </div>
  </div>
);

export default Status;
